import { render, staticRenderFns } from "./SaleEditAwsDocumentsSettings.vue?vue&type=template&id=76348962&scoped=true"
import script from "./SaleEditAwsDocumentsSettings.vue?vue&type=script&lang=ts"
export * from "./SaleEditAwsDocumentsSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76348962",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76348962')) {
      api.createRecord('76348962', component.options)
    } else {
      api.reload('76348962', component.options)
    }
    module.hot.accept("./SaleEditAwsDocumentsSettings.vue?vue&type=template&id=76348962&scoped=true", function () {
      api.rerender('76348962', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sales/SaleEditAwsDocumentsSettings.vue"
export default component.exports